(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-review-confidence"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-yaga-review-confidence]');

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function(character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
      });
    }

    function formatDate(value) {
      if (!value) return '';
      var date = new Date(String(value).length === 10 ? value + 'T12:00:00' : value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    }

    function selectReviews(reviews) {
      var eligible = reviews.filter(function(review) {
        return Number(review.rating) >= 4 && String(review.content || '').trim();
      });
      var storeReview = eligible.find(function(review) {
        return review.reviewType === 'store' || !review.productName;
      });
      var productReview = eligible.find(function(review) {
        return review.reviewType === 'review' || Boolean(review.productName);
      });
      var selected = [];
      [storeReview, productReview].forEach(function(review) {
        if (review && selected.indexOf(review) === -1) selected.push(review);
      });
      eligible.forEach(function(review) {
        if (selected.length < 6 && selected.indexOf(review) === -1) selected.push(review);
      });
      return selected.slice(0, 6);
    }

    function cardTemplate(root, review) {
      var rating = Math.max(1, Math.min(5, Math.round(Number(review.rating) || 5)));
      var stars = '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(rating);
      var isProduct = review.reviewType === 'review' || Boolean(review.productName);
      var reviewType = isProduct ? root.dataset.productReview : root.dataset.storeReview;
      var source = review.productName || root.dataset.storeName || reviewType;
      var verification = review.verified ? root.dataset.verifiedReview : root.dataset.klaviyoReview;
      var date = formatDate(review.date || review.created);
      return [
        '<article class="yaga-review-confidence__card">',
          '<div class="yaga-review-confidence__card-top">',
            '<span class="yaga-review-confidence__card-stars" aria-label="', rating, ' out of 5 stars">', stars, '</span>',
            '<span class="yaga-review-confidence__card-type">', escapeHtml(reviewType), '</span>',
          '</div>',
          '<h3>', escapeHtml(review.title || review.productName || root.dataset.reviewFallbackTitle), '</h3>',
          '<p class="yaga-review-confidence__card-text">', escapeHtml(review.content), '</p>',
          '<div class="yaga-review-confidence__card-meta">',
            '<span>', escapeHtml(source), '</span>',
            '<span class="yaga-review-confidence__verified">', escapeHtml(verification), date ? ' · ' + escapeHtml(date) : '', '</span>',
          '</div>',
        '</article>'
      ].join('');
    }

    function updateNavigation(root) {
      var track = root.querySelector('[data-review-track]');
      var previous = root.querySelector('[data-review-previous]');
      var next = root.querySelector('[data-review-next]');
      if (!track || !previous || !next) return;

      var hasOverflow = track.scrollWidth > track.clientWidth + 2;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || track.scrollLeft <= 4;
      next.disabled = !hasOverflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function moveReviews(root, direction) {
      var track = root.querySelector('[data-review-track]');
      if (!track) return;
      var card = track.querySelector('.yaga-review-confidence__card');
      var distance = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.85;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    function bindNavigation(root) {
      if (root.dataset.reviewNavigationReady === 'true') return;
      var track = root.querySelector('[data-review-track]');
      var previous = root.querySelector('[data-review-previous]');
      var next = root.querySelector('[data-review-next]');
      if (!track || !previous || !next) return;

      root.dataset.reviewNavigationReady = 'true';
      previous.addEventListener('click', function() { moveReviews(root, -1); });
      next.addEventListener('click', function() { moveReviews(root, 1); });
      track.addEventListener('scroll', function() { updateNavigation(root); }, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(function() { updateNavigation(root); }).observe(track);
      }
      updateNavigation(root);
    }

    function renderRoot(root, payload) {
      var summary = payload && payload.summary ? payload.summary : {};
      var rating = Number(summary.average || root.dataset.fallbackRating || 0);
      var ratingNode = root.querySelector('[data-summary-rating]');
      var starsNode = root.querySelector('[data-rating-stars]');
      var track = root.querySelector('[data-review-track]');

      if (ratingNode && rating) ratingNode.textContent = rating.toFixed(2);
      if (starsNode && rating) {
        starsNode.style.setProperty('--star-fill', Math.max(0, Math.min(100, rating * 20)) + '%');
        starsNode.setAttribute('aria-label', root.dataset.ratingLabel.replace('__rating__', rating.toFixed(2)));
      }

      if (!track) return;
      var reviews = selectReviews(Array.isArray(payload && payload.reviews) ? payload.reviews : []);
      if (reviews.length) {
        track.innerHTML = reviews.map(function(review) { return cardTemplate(root, review); }).join('');
        track.scrollLeft = 0;
        requestAnimationFrame(function() { updateNavigation(root); });
      }
    }

    function normalizePayload(payload) {
      var summary = payload && payload.summary ? payload.summary : {};
      var reviews = Array.isArray(payload && payload.reviews) ? payload.reviews : [];
      return {
        summary: {
          average: summary.star_rating,
          count: summary.review_count
        },
        reviews: reviews.map(function(review) {
          return {
            rating: review.rating,
            title: review.title,
            content: review.content,
            productName: review.product && review.product.name,
            reviewType: review.is_store ? 'store' : 'review',
            verified: Boolean(review.verified),
            created: review.created_at
          };
        })
      };
    }

    function loadFeed(url) {
      if (window.YAGA_KLAVIYO_HOME_REVIEWS) return Promise.resolve(window.YAGA_KLAVIYO_HOME_REVIEWS);
      if (window.YAGA_KLAVIYO_HOME_REVIEWS_PROMISE) return window.YAGA_KLAVIYO_HOME_REVIEWS_PROMISE;
      window.YAGA_KLAVIYO_HOME_REVIEWS_PROMISE = fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Klaviyo reviews request failed');
        return response.json();
      }).then(normalizePayload).catch(function() { return {}; });
      return window.YAGA_KLAVIYO_HOME_REVIEWS_PROMISE;
    }

    roots.forEach(function(root) {
      var url = root.dataset.feedUrl;
      bindNavigation(root);
      renderRoot(root, {});
      if (!url) return;
      loadFeed(url).then(function(payload) { renderRoot(root, payload); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
